import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgCampground(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.2479 1.49485C9.96885 1.01826 9.35626 0.858148 8.87968 1.13722C8.40309 1.4163 8.24298 2.02889 8.52205 2.50547L10.3455 5.61943L1.92453 20.0002H1C0.447715 20.0002 0 20.4479 0 21.0002C0 21.5525 0.447715 22.0002 1 22.0002H22C22.5523 22.0002 23 21.5525 23 21.0002C23 20.4479 22.5523 20.0002 22 20.0002H21.0841L12.6632 5.61943L14.4866 2.50547C14.7657 2.02889 14.6056 1.4163 14.129 1.13722C13.6524 0.858148 13.0398 1.01826 12.7607 1.49485L11.5043 3.64045L10.2479 1.49485ZM9.99946 14.5574C10.6791 13.4246 12.3208 13.4245 13.0006 14.5572L16.2662 19.9986L6.73358 20.0005L9.99946 14.5574Z", fill: "currentColor" })));
}
export default SvgCampground;
